(() => {
  const root = document.querySelector('[data-recipes-grid]');
  if (!root) return;

  const dataEl = document.getElementById('RecipesData');
  if (!dataEl) return;

  let payload = { recipes: [], dietary_key: [] };
  try { payload = JSON.parse(dataEl.textContent || '{}'); }
  catch (e) { console.error('RecipesData JSON parse failed:', e); return; }

  const recipes = Array.isArray(payload.recipes) ? payload.recipes : [];

  const cardsEl = root.querySelector('[data-recipes-cards]');
  const chipsEl = root.querySelector('[data-recipes-chips]');
  const countEl = root.querySelector('[data-recipes-count]');
  const emptyEl = root.querySelector('[data-recipes-empty]');
  const sortEl = root.querySelector('[data-recipes-sort]');

  const qEl = root.querySelector('[data-recipes-q]');
  const qClearEl = root.querySelector('[data-recipes-q-clear]');
  const qModeEl = root.querySelector('[data-recipes-q-mode]');
  const communityOnlyEl = root.querySelector('[data-recipes-community-only]');
  const suggestEl = root.querySelector('[data-recipes-suggest]');

  const enableSearch = root.dataset.enableSearch === 'true';
  const showCount = root.dataset.showCount === 'true';

  const timeBuckets = (root.dataset.timeBuckets || '<15,15-30,30-60,60+')
    .split(',')
    .map(s => s.trim())
    .filter(Boolean);

  const esc = (s) => String(s || '').replace(/[&<>"']/g, (c) => ({
    '&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#039;'
  }[c]));

  const setParam = (key, arrOrStr) => {
    const url = new URL(window.location.href);
    const p = url.searchParams;
    if (Array.isArray(arrOrStr)) {
      const v = arrOrStr.join(',');
      if (v) p.set(key, v); else p.delete(key);
    } else {
      const v = (arrOrStr || '').toString();
      if (v) p.set(key, v); else p.delete(key);
    }
    window.history.replaceState({}, '', url.toString());
  };

  const cleanArray = (arr) => {
    if (!Array.isArray(arr)) return [];
    return arr.map(v => String(v || '').trim()).filter(v => v && v.toLowerCase() !== 'all');
  };

  const cleanDefault = (v) => {
    const s = String(v || '').trim();
    return (!s || s.toLowerCase() === 'all') ? '' : s;
  };

  const cleanDefaultList = (v) => {
    const s = String(v || '').trim();
    if (!s || s.toLowerCase() === 'all') return [];
    return s.split(',').map(x => x.trim()).filter(Boolean);
  };

  const defaults = {
    appliance: cleanDefaultList(root.dataset.defaultAppliance),
    meal_type: cleanDefault(root.dataset.defaultMealType),
    dietary: cleanDefaultList(root.dataset.defaultDietary),
  };

  const params = new URLSearchParams(window.location.search);

  const state = {
    q: (params.get('q') || '').trim(),
    q_mode: (params.get('q_mode') || '').trim(),
    community_only: (params.get('community_only') || '').trim(),
    appliance: (params.get('appliance') || defaults.appliance.join(',')).split(',').map(s => s.trim()).filter(Boolean),
    dietary: (params.get('dietary') || defaults.dietary.join(',')).split(',').map(s => s.trim()).filter(Boolean),
    meal_type: (params.get('meal_type') || defaults.meal_type).split(',').map(s => s.trim()).filter(Boolean),
    difficulty: (params.get('difficulty') || '').split(',').map(s => s.trim()).filter(Boolean),
    time: (params.get('time') || '').split(',').map(s => s.trim()).filter(Boolean),
    sort: (params.get('sort') || 'popular').trim(),
  };

  const cleanStateAll = () => {
    state.appliance = cleanArray(state.appliance);
    state.meal_type = cleanArray(state.meal_type);
    state.dietary = cleanArray(state.dietary);
    state.difficulty = cleanArray(state.difficulty);
    state.time = cleanArray(state.time);

    setParam('appliance', state.appliance);
    setParam('meal_type', state.meal_type);
    setParam('dietary', state.dietary);
    setParam('difficulty', state.difficulty);
    setParam('time', state.time);
    setParam('sort', state.sort);
    setParam('q_mode', state.q_mode);
    setParam('community_only', state.community_only);
  };

  cleanStateAll();

  const cssEscape = (s) => {
    if (window.CSS && typeof window.CSS.escape === 'function') return window.CSS.escape(String(s || ''));
    return String(s || '').replace(/[^a-zA-Z0-9_-]/g, '\\$&');
  };

  const getIconTemplate = (key) => {
    const bank = root.querySelector('[data-icon-bank]') || document.querySelector('[data-icon-bank]');
    if (!bank) return null;
    return bank.querySelector(`template[data-icon-template="${cssEscape(key)}"]`);
  };

  const cloneIcon = (key) => {
    const tpl = getIconTemplate(key);
    if (!tpl) return null;

    const frag = tpl.content.cloneNode(true);
    const svg = frag.querySelector('svg');
    if (svg) return svg;
    const el = frag.firstElementChild;
    return el || null;
  };

  const hydrateIcons = (container) => {
    if (!container) return;

    container.querySelectorAll('[data-icon-key]').forEach((slot) => {
      if (slot.dataset.iconHydrated === '1') return;

      const key = slot.getAttribute('data-icon-key') || '';
      if (!key) return;

      const iconNode = cloneIcon(key);
      if (!iconNode) return;

      slot.innerHTML = '';
      slot.appendChild(iconNode.cloneNode(true));
      slot.dataset.iconHydrated = '1';
    });
  };

  const splitRaw = (raw) => {
    const s = String(raw || '').trim();
    if (!s) return [];
    if (s.includes('•')) return s.split('•').map(x => x.trim()).filter(Boolean);
    if (s.includes(',')) return s.split(',').map(x => x.trim()).filter(Boolean);
    return [s];
  };

  const slugify = (str) => String(str || '')
    .toLowerCase()
    .trim()
    .replace(/['"]/g, '')
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');

  recipes.forEach(r => {
    const labels = splitRaw(r.dietary_label_raw);
    const shorts = splitRaw(r.dietary_short_label_raw);

    const max = Math.max(labels.length, shorts.length);
    const vals = [];
    const outLabels = [];
    const outShorts = [];

    for (let i = 0; i < max; i++) {
      const lab = (labels[i] || '').trim();
      const sh = (shorts[i] || '').trim();
      const base = lab || sh;
      if (!base) continue;

      vals.push(slugify(base));
      outLabels.push(lab || sh);
      outShorts.push(sh || lab);
    }

    r.dietary = vals;
    r.dietary_labels = outLabels;
    r.dietary_shorts = outShorts;

    r.community_supplied = !!r.community_supplied;

    const title = String(r.title || '');
    const short = String(r.short || '');
    const difficulty = String(r.difficulty || '');
    const meal = String(r.meal_type || '');

    const applianceCats = (r.appliance_category_labels || []).join(' ');
    const applianceModels = (r.appliance_labels || []).join(' ');
    const dietaryText = [...(r.dietary_labels || []), ...(r.dietary_shorts || [])].join(' ');
    const ingredients = String(r.ingredients_text || '');
    const steps = String(r.steps_text || '');

    r.__search_all = (
      [title, short, difficulty, meal, applianceCats, applianceModels, dietaryText, ingredients, steps]
        .join(' ')
        .toLowerCase()
    );

    r.__search_ingredients = ingredients.toLowerCase();
    r.__search_steps = steps.toLowerCase();
  });

  const queryTokens = (q) => {
    const s = String(q || '').toLowerCase().trim();
    if (!s) return [];
    return s.split(/\s+/).map(t => t.trim()).filter(Boolean);
  };

  const matchesTokens = (haystack, tokens) => {
    if (!tokens.length) return true;
    const h = String(haystack || '');
    return tokens.every(t => h.includes(t));
  };

  const parseTimeBucket = (bucket) => {
    const b = String(bucket || '').replace(/\s/g, '');
    if (!b) return null;

    if (b.includes('-')) {
      const [a, z] = b.split('-').map(n => parseInt(n, 10));
      if (!Number.isFinite(a) || !Number.isFinite(z)) return null;
      return { type: 'range', min: a, max: z };
    }
    if (b.endsWith('+')) {
      const min = parseInt(b.replace('+',''), 10);
      return Number.isFinite(min) ? { type: 'min', min } : null;
    }
    if (b.startsWith('<')) {
      const max = parseInt(b.replace('<',''), 10);
      return Number.isFinite(max) ? { type: 'max', max } : null;
    }
    const n = parseInt(b, 10);
    return Number.isFinite(n) ? { type: 'exact', n } : null;
  };

  const matchesTime = (total, bucket) => {
    const rule = parseTimeBucket(bucket);
    if (!rule || !Number.isFinite(total)) return false;
    if (rule.type === 'range') return total >= rule.min && total <= rule.max;
    if (rule.type === 'min') return total >= rule.min;
    if (rule.type === 'max') return total < rule.max;
    if (rule.type === 'exact') return total === rule.n;
    return false;
  };

  const matchAny = (arr, selected) => (!selected.length) || (arr || []).some(v => selected.includes(v));
  const matchAll = (arr, selected) => (!selected.length) || selected.every(v => (arr || []).includes(v));

  const buildFacet = () => {
    const facet = {
      appliance: {},
      dietary: {},
      meal_type: {},
      difficulty: {},
      time: timeBuckets.map(b => ({ value: b, label: b })),
    };

    recipes.forEach(r => {
      (r.appliance_categories || []).forEach((slug, i) => {
        if (!slug) return;
        if (!facet.appliance[slug]) {
          facet.appliance[slug] = {
            label: (r.appliance_category_labels && r.appliance_category_labels[i]) ? r.appliance_category_labels[i] : slug,
            icon_key: slug
          };
        }
      });

      (r.dietary || []).forEach((slug, i) => {
        if (!slug) return;
        facet.dietary[slug] = (r.dietary_labels && r.dietary_labels[i]) ? r.dietary_labels[i] : slug;
      });

      if (r.meal_type) facet.meal_type[r.meal_type] = r.meal_type;
      if (r.difficulty) facet.difficulty[r.difficulty] = r.difficulty;
    });

    const toListObj = (obj) => Object.keys(obj).sort().map(k => ({ value: k, label: obj[k] }));
    const toListAppliance = (obj) => Object.keys(obj).sort().map(k => ({
      value: k,
      label: obj[k].label,
      icon_key: obj[k].icon_key
    }));

    return {
      appliance: toListAppliance(facet.appliance),
      dietary: toListObj(facet.dietary),
      meal_type: toListObj(facet.meal_type),
      difficulty: toListObj(facet.difficulty),
      time: facet.time,
    };
  };

  const facet = buildFacet();

  const renderFacet = (key, items) => {
    const group = root.querySelector(`[data-filter="${key}"]`);
    if (!group) return;
    const body = group.querySelector('[data-body]');
    if (!body) return;

    const selected = new Set(cleanArray(state[key] || []));
    body.innerHTML = items.map(it => {
      const id = `f-${key}-${it.value}`.replace(/[^a-z0-9_-]/gi, '');
      const checked = selected.has(it.value) ? 'checked' : '';

      if (key === 'appliance') {
        return `
          <label class="recipes-check recipes-check--appliance" for="${id}">
            <input id="${id}" type="checkbox" value="${esc(it.value)}" data-filter-item data-filter-key="${esc(key)}" ${checked}>
            <span class="recipes-check__appliance-row">
              <span class="recipes-check__appliance-icon" aria-hidden="true" data-icon-key="${esc(it.icon_key || it.value)}"></span>
              <span class="recipes-check__appliance-text">${esc(it.label)}</span>
            </span>
          </label>
        `;
      }

      return `
        <label class="recipes-check" for="${id}">
          <input id="${id}" type="checkbox" value="${esc(it.value)}" data-filter-item data-filter-key="${esc(key)}" ${checked}>
          <span>${esc(it.label)}</span>
        </label>
      `;
    }).join('');

    hydrateIcons(body);
  };

  renderFacet('appliance', facet.appliance);
  renderFacet('meal_type', facet.meal_type);
  renderFacet('dietary', facet.dietary);
  renderFacet('time', facet.time);
  renderFacet('difficulty', facet.difficulty);

  root.querySelectorAll('.recipes-filter-group').forEach(g => {
    const t = g.querySelector('[data-toggle]');
    const b = g.querySelector('[data-body]');
    if (!t || !b) return;

    t.addEventListener('click', () => {
      const isOpen = g.classList.toggle('is-open');
      b.hidden = !isOpen;
    });
  });

  const buildSuggestionPool = () => {
    const set = new Set();
    recipes.forEach(r => {
      if (r.title) set.add(String(r.title));
      (r.dietary_labels || []).forEach(x => x && set.add(String(x)));
      (r.dietary_shorts || []).forEach(x => x && set.add(String(x)));
      (r.appliance_category_labels || []).forEach(x => x && set.add(String(x)));

      const ing = String(r.ingredients_text || '').toLowerCase();
      ing.split(/[^a-z0-9]+/).forEach(w => { if (w.length >= 4) set.add(w); });
    });

    return Array.from(set)
      .map(s => String(s).trim())
      .filter(Boolean)
      .sort((a, b) => a.localeCompare(b));
  };

  const suggestionPool = buildSuggestionPool();

  const hideSuggest = () => {
    if (!suggestEl) return;
    suggestEl.hidden = true;
    suggestEl.innerHTML = '';
  };

  const showSuggest = (items) => {
    if (!suggestEl) return;
    if (!items.length) return hideSuggest();

    suggestEl.innerHTML = items.map((txt) => `
      <button type="button" class="recipes-suggest__item" data-suggest-item data-suggest-value="${esc(txt)}">
        ${esc(txt)}
      </button>
    `).join('');
    suggestEl.hidden = false;
  };

  const pickSuggestions = (q) => {
    const s = String(q || '').toLowerCase().trim();
    if (s.length < 2) return [];
    const out = [];
    for (let i = 0; i < suggestionPool.length; i++) {
      const cand = suggestionPool[i];
      if (String(cand).toLowerCase().includes(s)) out.push(cand);
      if (out.length >= 8) break;
    }
    return out;
  };

  if (enableSearch && qEl) {
    qEl.value = state.q;
    if (qClearEl) qClearEl.hidden = !state.q;
    if (qModeEl) qModeEl.checked = (state.q_mode === 'ingredients');
    if (communityOnlyEl) communityOnlyEl.checked = (state.community_only === 'true');
  }

  const dateValue = (r) => {
    const d = r.publish_date ? Date.parse(r.publish_date) : 0;
    return Number.isFinite(d) ? d : 0;
  };

  const featuredBoost = (a, b) => (b.featured ? 1 : 0) - (a.featured ? 1 : 0);

  const renderCard = (r) => {
    const metaLeft = [
      r.total ? `${r.total} mins` : '',
      r.difficulty || ''
    ].filter(Boolean).join(' • ');

    const shorts = (r.dietary_shorts || []).map(s => String(s || '').trim()).filter(Boolean);
    const metaRight = shorts.length ? shorts.join(' | ') : '';

    return `
      <a class="recipe-card" href="${esc(r.url)}">
        <div class="recipe-card__media">${r.image ? `<img src="${esc(r.image)}" loading="lazy" alt="${esc(r.title)}">` : ''}</div>
        <div class="recipe-card__body">
          <div class="recipe-card__title-row">
            <div class="recipe-card__title">${esc(r.title)}</div>
          </div>
          <div class="recipe-card__meta-row">
            <div class="recipe-card__meta-left">${esc(metaLeft)}</div>
            ${metaRight ? `<div class="recipe-card__meta-right">${esc(metaRight)}</div>` : ''}
          </div>
        </div>
      </a>
    `;
  };

  const render = (list) => { if (cardsEl) cardsEl.innerHTML = list.map(renderCard).join(''); };

  const chipFor = (key, value, label) => `
    <button class="chip" type="button" data-chip data-chip-key="${esc(key)}" data-chip-value="${esc(value)}">
      ${esc(label)} <span aria-hidden="true">×</span>
    </button>
  `;

  const renderChips = () => {
    if (!chipsEl) return;
    const chips = [];
    if (state.q) chips.push(chipFor('q', state.q, `Search: ${state.q}`));
    if (state.q_mode === 'ingredients') chips.push(chipFor('q_mode', 'ingredients', `Ingredients only`));
    if (state.community_only === 'true') chips.push(chipFor('community_only', 'true', `Community supplied only`));

    const dictFor = (key) => {
      if (key === 'dietary') return new Map(facet.dietary.map(x => [x.value, x.label]));
      if (key === 'appliance') return new Map(facet.appliance.map(x => [x.value, x.label]));
      if (key === 'meal_type') return new Map(facet.meal_type.map(x => [x.value, x.label]));
      if (key === 'difficulty') return new Map(facet.difficulty.map(x => [x.value, x.label]));
      if (key === 'time') return new Map(facet.time.map(x => [x.value, x.label]));
      return new Map();
    };

    const pushFrom = (key) => {
      const dict = dictFor(key);
      cleanArray(state[key] || []).forEach(v => chips.push(chipFor(key, v, dict.get(v) || v)));
    };

    pushFrom('appliance');
    pushFrom('meal_type');
    pushFrom('dietary');
    pushFrom('time');
    pushFrom('difficulty');

    chipsEl.innerHTML = chips.join('');
  };

  const applyFilters = () => {
    cleanStateAll();

    let out = recipes.slice();

    const tokens = queryTokens(state.q);
    if (tokens.length) {
      out = out.filter(r => {
        if (state.q_mode === 'ingredients') return matchesTokens(r.__search_ingredients, tokens);
        return matchesTokens(r.__search_all, tokens);
      });
    }

    if (state.community_only === 'true') {
      out = out.filter(r => r.community_supplied === true);
    }

    if (state.appliance.length) out = out.filter(r => matchAny(r.appliance_categories, state.appliance));
    if (state.dietary.length) out = out.filter(r => matchAll(r.dietary, state.dietary));
    if (state.meal_type.length) out = out.filter(r => state.meal_type.includes(r.meal_type));
    if (state.difficulty.length) out = out.filter(r => state.difficulty.includes(r.difficulty));
    if (state.time.length) out = out.filter(r => state.time.some(b => matchesTime(Number(r.total || 0), b)));

    out.sort((a, b) => {
      const fb = featuredBoost(a, b);
      if (fb !== 0) return fb;

      if (state.sort === 'popular') {
        const ap = Number(a.popularity || 0), bp = Number(b.popularity || 0);
        if (ap !== bp) return bp - ap;
        return dateValue(b) - dateValue(a);
      }
      if (state.sort === 'newest') return dateValue(b) - dateValue(a);
      if (state.sort === 'time_asc') return (a.total || 0) - (b.total || 0);
      if (state.sort === 'time_desc') return (b.total || 0) - (a.total || 0);
      if (state.sort === 'title_asc') return String(a.title).localeCompare(String(b.title));
      return 0;
    });

    render(out);
    renderChips();

    if (showCount && countEl) countEl.textContent = `${out.length} recipe${out.length === 1 ? '' : 's'}`;
    if (emptyEl) emptyEl.hidden = out.length !== 0;
  };

  root.addEventListener('change', (e) => {
    const t = e.target;
    if (!(t instanceof HTMLInputElement)) return;

    if (t.matches('[data-recipes-q-mode]')) {
      state.q_mode = t.checked ? 'ingredients' : '';
      setParam('q_mode', state.q_mode);
      applyFilters();
      return;
    }

    if (t.matches('[data-recipes-community-only]')) {
      state.community_only = t.checked ? 'true' : '';
      setParam('community_only', state.community_only);
      applyFilters();
      return;
    }

    if (!t.matches('[data-filter-item]')) return;

    const key = t.dataset.filterKey;
    if (!key) return;

    const selected = new Set(cleanArray(state[key] || []));
    if (t.checked) selected.add(t.value);
    else selected.delete(t.value);

    state[key] = Array.from(selected);
    setParam(key, state[key]);
    applyFilters();
  });

  root.addEventListener('click', (e) => {
    const sugBtn = e.target.closest('[data-suggest-item]');
    if (sugBtn && qEl) {
      const v = sugBtn.getAttribute('data-suggest-value') || '';
      qEl.value = v;
      state.q = v.trim();
      setParam('q', state.q);
      if (qClearEl) qClearEl.hidden = !state.q;
      hideSuggest();
      applyFilters();
      return;
    }

    const btn = e.target.closest('[data-chip]');
    if (!btn) return;

    const key = btn.dataset.chipKey;
    const value = btn.dataset.chipValue;

    if (key === 'q') {
      state.q = '';
      if (qEl) qEl.value = '';
      setParam('q', '');
      if (qClearEl) qClearEl.hidden = true;
      hideSuggest();
    } else if (key === 'q_mode') {
      state.q_mode = '';
      setParam('q_mode', '');
      if (qModeEl) qModeEl.checked = false;
    } else if (key === 'community_only') {
      state.community_only = '';
      setParam('community_only', '');
      if (communityOnlyEl) communityOnlyEl.checked = false;
    } else {
      state[key] = cleanArray(state[key] || []).filter(v => v !== value);
      setParam(key, state[key]);

      const input = root.querySelector(
        `[data-filter-item][data-filter-key="${cssEscape(key)}"][value="${cssEscape(value)}"]`
      );
      if (input) input.checked = false;
    }

    applyFilters();
  });

  root.querySelectorAll('[data-recipes-clear]').forEach(btn => {
    btn.addEventListener('click', () => {
      state.q = '';
      state.q_mode = '';
      state.community_only = '';
      state.appliance = [];
      state.dietary = [];
      state.meal_type = [];
      state.difficulty = [];
      state.time = [];

      setParam('q', '');
      setParam('q_mode', '');
      setParam('community_only', '');
      ['appliance','dietary','meal_type','difficulty','time'].forEach(k => setParam(k, []));

      if (qEl) qEl.value = '';
      if (qClearEl) qClearEl.hidden = true;
      if (qModeEl) qModeEl.checked = false;
      if (communityOnlyEl) communityOnlyEl.checked = false;

      hideSuggest();
      root.querySelectorAll('[data-filter-item]').forEach(i => { i.checked = false; i.disabled = false; });
      applyFilters();
    });
  });

  if (enableSearch && qEl) {
    let to;
    qEl.addEventListener('input', () => {
      clearTimeout(to);
      to = setTimeout(() => {
        state.q = (qEl.value || '').trim();
        setParam('q', state.q);
        if (qClearEl) qClearEl.hidden = !state.q;

        const sug = pickSuggestions(state.q);
        if (state.q && sug.length) showSuggest(sug);
        else hideSuggest();

        applyFilters();
      }, 120);
    });

    qEl.addEventListener('focus', () => {
      const sug = pickSuggestions(qEl.value || '');
      if ((qEl.value || '').trim() && sug.length) showSuggest(sug);
    });

    qEl.addEventListener('blur', () => {
      setTimeout(hideSuggest, 120);
    });
  }

  if (qClearEl && qEl) {
    qClearEl.addEventListener('click', () => {
      state.q = '';
      qEl.value = '';
      setParam('q', '');
      qClearEl.hidden = true;
      hideSuggest();
      applyFilters();
    });
  }

  if (sortEl) {
    sortEl.value = state.sort;
    sortEl.addEventListener('change', () => {
      state.sort = sortEl.value;
      setParam('sort', state.sort);
      applyFilters();
    });
  }

  root.querySelectorAll('.recipes-filter-group').forEach(g => {
    const b = g.querySelector('[data-body]');
    if (!b) return;
    b.hidden = !g.classList.contains('is-open');
  });

  applyFilters();
})();